import classNames from "classnames";
import React, { type ReactNode } from "react";

interface CheckboxTileProps {
  id?: string;
  title: string;
  subtitle?: ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
}

export const CheckboxTile = ({
  id,
  title,
  subtitle,
  checked,
  onChange,
  className,
}: CheckboxTileProps) => {
  return (
    <div
      id={id}
      onClick={() => onChange(!checked)}
      className={classNames(
        "border border-solid rounded-xl p-4 flex items-start gap-3 cursor-pointer transition-all duration-200 font-sans select-none shadow-sm",
        checked
          ? "border-primary-500 bg-primary-50/40 dark:border-primary-400 dark:bg-primary-950/15"
          : "border-primary-200/80 bg-white hover:bg-primary-50/20 dark:border-primary-800/80 dark:bg-content-800 dark:hover:bg-content-700/30",
        className
      )}
    >
      <div
        className={classNames(
          "mt-0.5 w-5 h-5 rounded flex items-center justify-center transition-all shrink-0",
          checked
            ? "bg-primary-600 text-white dark:bg-primary-500 dark:text-content-950"
            : "border-2 border-primary-200 bg-white dark:border-primary-700 dark:bg-content-900"
        )}
      >
        {checked && <span className="icon-[ph--check] h-3.5 w-3.5 font-bold" />}
      </div>
      <div className="min-w-0 flex-1">
        <span className="font-header font-bold block text-content-900 dark:text-content-100 leading-tight">
          {title}
        </span>
        {subtitle && (
          <span
            className={classNames(
              "text-xs block mt-1 leading-normal",
              checked ? "text-primary-800 dark:text-primary-200" : "text-content-500 dark:text-content-400"
            )}
          >
            {subtitle}
          </span>
        )}
      </div>
    </div>
  );
};

CheckboxTile.displayName = "CheckboxTile";
